import type {Room} from '@/redux/v1/models';

import {useMemo} from 'react';
import {useTranslation} from 'react-i18next';

const areAllRoomsEqual = (rooms: Array<Room>) => {
  return rooms.every(
    (room) =>
      room.type.name === rooms[0].type.name &&
      room.supplierType === rooms[0].supplierType
  );
};

export const useSimplifiedRoomString = (rooms: Array<Room>) => {
  const {t} = useTranslation(['general']);

  return useMemo(() => {
    let commonRoomTypeLabel = '';

    if (rooms.length > 0) {
      const [firstRoom] = rooms;

      commonRoomTypeLabel =
        rooms.length === 1 || areAllRoomsEqual(rooms)
          ? firstRoom.type.name
          : t('general:room');
    }

    return commonRoomTypeLabel
      ? t('general:roomTypeDescription', {
          roomType: commonRoomTypeLabel,
          count: rooms.length,
        })
      : '';
  }, [rooms, t]);
};
